import { defineStore } from "pinia";
import { ref } from "vue";
import { getSystemConfig } from "@/api/admin";
// loading状态管理
const requestTotal = ref(0);
// 是否允许添加loading
let loadingLock = false;
let loadingTotal = 0;
const systemConfig = ref();
const businessConfig = ref();
/**
 * 全局loading管理
 */
async function updateRequestLoading(num) {
  loadingTotal += num;
  if (num > 0 && requestTotal.value === 0) {
    await wait(1000);
  }
  if (num > 0 && loadingLock) return;
  requestTotal.value = loadingTotal;
}
/**
 * 全局loading清除
 */
async function clearRequestLoading() {
  requestTotal.value = 0;
  loadingTotal = 0;
  // 一秒内禁止新增loading
  loadingLock = true;
  await wait(1000);
  loadingLock = false;
}
async function fetchSystemConfig() {
  if (!systemConfig.value) {
    const data = await getSystemConfig('SYS_INFO');
    systemConfig.value = Object.fromEntries(data.map(item => {
      return [item.configKey, item.configVal];
    }));
  }
  return systemConfig.value;
}
async function fetchSystemBusinessConfig() {
  if (!businessConfig.value) {
    const data = await getSystemConfig('BUSINESS_CONFIG');
    businessConfig.value = Object.fromEntries(data.map(item => {
      return [item.configKey, item.configVal];
    }));
  }
  return businessConfig.value;
}
export default defineStore("config", () => {
  return {
    requestTotal,
    updateRequestLoading,
    clearRequestLoading,
    fetchSystemConfig,
    fetchSystemBusinessConfig
  };
});